import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const zoneTypeApiRoutes = {
    list: apiDataManagerBaseURL + "zonetypes",
    load: apiDataManagerBaseURL + "zonetypes/",
    create: apiDataManagerBaseURL + "zonetypes",
    update: apiDataManagerBaseURL + "zonetypes/",
    delete: apiDataManagerBaseURL + "zonetypes/"
};

export class ZoneTypeAPI {
    static list(provider = '') {
        return API.authenticatedRequest({
            url: provider === '' ? zoneTypeApiRoutes.list : `${zoneTypeApiRoutes.list}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(id) {
        return API.authenticatedRequest({
            url: zoneTypeApiRoutes.load + id,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(zoneType) {
        return API.authenticatedRequest({
            url: zoneTypeApiRoutes.create,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(zoneType)
        });
    }

    static update(id, zoneType) {
        return API.authenticatedRequest({
            url: zoneTypeApiRoutes.update + id,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(zoneType)
        });
    }

    static delete(id) {
        return API.authenticatedRequest({
            url: zoneTypeApiRoutes.delete + id,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}